import axios from 'axios'

document.addEventListener('DOMContentLoaded', () => {
  const checkoutButton = document.getElementById("upgrade-pro-button");
  const stripeKey = checkoutButton.dataset.stripeKey
  const stripe = Stripe(stripeKey);

  if (checkoutButton) {

    getToken()

    checkoutButton.addEventListener("click", function () {
      checkoutButton.disabled = true

      let headers = {
        headers: {
          Authorization: localStorage.getItem('token', ''),
        }
      }
      let params = {
        plan: document.querySelector('.switch-item--active').id === 'yearly' ? 'yearly' : 'monthly'
      }
      axios.post(`${window.location.origin}/pro/checkout_session.json`, params, headers)
        .then(function (response) {
          return stripe.redirectToCheckout({ sessionId: response.data.session_id });
        })
        .then(function (result) {
          if (result.error) {
            checkoutButton.disabled = false
            console.log(result.error.message);
          }
        })
        .catch(function (error) {
          checkoutButton.disabled = false
          console.error("Error:", error);
        });
    });


    function getToken () {
      let token = localStorage.getItem('token')
      if (token === null || token === '') {
        axios.get('/api_tokens/new.json')
          .then(response => {
            localStorage.setItem('token', response.data.jwt)
          })
      }
    }
  }
})
